
import { defineComponent } from 'vue'
import axios from 'axios'
import UsersList from './components/UsersList.vue'
import AddUser from './components/AddUser.vue'
import ToggleMode from './components/ToggleMode.vue'

import { library } from '@fortawesome/fontawesome-svg-core'
import { faUserFriends } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
library.add(faUserFriends)

interface User {
  id: number;
  name: string;
  username: string;
  email: string;
}

export default defineComponent({
  name: 'App',
  components: {
    UsersList,
    AddUser,
    ToggleMode,
    FontAwesomeIcon
  },
  data () {
    return {
      users: [] as User[], // users list fetched from jsonplaceholder
      isDarkThemeOn: false
    }
  },
  mounted () {
    axios
      .get('https://jsonplaceholder.typicode.com/users')
      .then((response) => (this.users = response.data))
      .catch((error) => console.log(error))

    /* On first visit, we check if User has a Light/Dark theme preference set.
     * The User can manually override this preference with the Theme Toggle,
     * which saves it to localStorage.
     */
    const localTheme = localStorage.getItem('theme')
    if (localTheme) {
      this.isDarkThemeOn = localTheme === 'dark'
      if (localTheme === 'dark') {
        document.documentElement.classList.add('dark')
      } else {
        document.documentElement.classList.remove('dark')
      }
    } else {
      // user has no preference in localStorage
      if (window.matchMedia('(prefers-color-scheme: dark)').matches) {
        document.documentElement.classList.add('dark')
        this.isDarkThemeOn = true
      } else {
        document.documentElement.classList.remove('dark')
        this.isDarkThemeOn = false
      }
    }
  },
  methods: {
    // Catches even emitted from ToggleMode, switches theme
    toggleTheme (theme: string) {
      if (theme === 'light') {
        this.isDarkThemeOn = false
        document.documentElement.classList.remove('dark')
        localStorage.setItem('theme', 'light')
      } else {
        this.isDarkThemeOn = true
        document.documentElement.classList.add('dark')
        localStorage.setItem('theme', 'dark')
      }
    },
    async addUser (newUser: User) {
      const newUsersList: User[] = [...this.users, newUser]
      this.users = newUsersList

      // await for table to update before scrolling to new User
      await this.users

      // scroll table to new User
      const usersTable = document.getElementById('usersTable') as HTMLElement
      usersTable.scrollBy({ top: 999, behavior: 'smooth' })
    },
    deleteLastUser () {
      if (confirm('Are you sure you want to delete last User?')) {
        const lastUserId = this.users[this.users.length - 1].id
        axios
          .delete(`https://jsonplaceholder.typicode.com/users/${lastUserId}`)
          .then((response) => {
            console.log(response)

            // if DELETE request is successful, update the UI
            if (response.status === 200) {
              const newUsersList = this.users.slice(0, -1)
              this.users = newUsersList
            }
          })
          .catch((error) => console.log(error))
      }
    },
    // Allows to sort the Users table by name/username, in ascending/descending order.
    sortUsers (sortingCol: keyof User, sortingOrder: string) {
      const usersCopy = [...this.users]
      usersCopy.sort((a, b) => {
        const propertyA = a[sortingCol]
        const propertyB = b[sortingCol]
        if (propertyA < propertyB) {
          return -1
        }
        if (propertyA > propertyB) {
          return 1
        }
        return 0
      })

      // if order is 'desc', reverse array before updating UI
      if (sortingOrder === 'desc') usersCopy.reverse()
      this.users = usersCopy
    }
  }
})
